import { render, staticRenderFns } from "./DiagnosticLabCategorySelect.vue?vue&type=template&id=0cb11e46&"
import script from "./DiagnosticLabCategorySelect.vue?vue&type=script&lang=js&"
export * from "./DiagnosticLabCategorySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports